import { Layout } from 'antd';
import styled, { css } from 'styled-components';

const { Header } = Layout;

export const StyledMainHeader = styled(Header)`
  box-shadow: 0px 20px 40px rgba(218, 218, 218, 0.2);
  line-height: inherit;
  padding: 0 8px;
`;

export const StyledUserDropdown = styled.div<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: transparent;
  border-radius: 20px;
  padding: 4px 8px 4px 4px;
  cursor: pointer;
  transition: all 0.3s;
  .user-name {
    color: #ffffff;
    margin: 0;
  }
  .anticon {
    transition: all 0.3s;
  }
  ${({ $active }) =>
    $active &&
    css`
      background-color: #fbfbfb;
      .user-name {
        color: #0b1a30;
      }
      .anticon {
        transform: rotate(180deg);
      }
    `}
  @media only screen and (max-width: 768px) {
    .user-name {
      display: none;
    }
  }
`;

export const StyledUserData = styled.span`
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #f4f4f4;
  padding-bottom: 16px;
  padding-top: 16px;
  span {
    font-size: 16px;
    color: #0b1a30;
    font-weight: bold;
    display: block;
    max-width: 180px;
    text-align: center;
  }
`;

export const StyledMenuItem = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
`;

export const StyledContactUs = styled.span`
  display: flex;
  align-items: center;
  height: 80px;
  padding: 16px;
`;
